import React from 'react'
import omit from 'lodash/omit'
import { withRouter } from 'react-router-dom'
import { makeLink, parseLocation } from '../../../common/utils/urlHelper'

const SearchBarFormPure = (props) => {
  const { location, history, children } = props
  let passProps = omit(props, ['location', 'router', 'onSubmit', 'role', 'method', 'action', 'match', 'history', 'staticContext'])

  const onSubmit = (event) => {
    event.preventDefault()

    // get query from form
    const form = event.target
    let query = {}
    Array.prototype.slice.call(form.elements)
      .filter(el => el.getAttribute('name') && el.value)
      .forEach((el) => {
        query[el.getAttribute('name')] = el.value
      })

    // only update query inside the from and keep the existing one
    let nextQuery = Object.assign({}, parseLocation(location), query)

    // remove page param when do search
    delete nextQuery.page

    history.push(makeLink(nextQuery))
  }

  return (
    <form role='search' method='get' action='/search' onSubmit={onSubmit} {...passProps}>
      {children}
    </form>
  )
}

export default withRouter(SearchBarFormPure)



// WEBPACK FOOTER //
// ./client/components/searchBar/searchBarForm.js